module.exports = __webpack_public_path__ + "static/img/home_logo.19d5d64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_logo.png
// module id = tESk
// module chunks = 4